export const SEO_ROUTES = {
  index: 'https://www.joeyfamily.com/',
  about: 'https://www.joeyfamily.com/about-us',
  pricing: 'https://www.joeyfamily.com/pricing',
  getStarted: 'https://www.joeyfamily.com/get-started',
  secureIphoneGuide: 'https://www.joeyfamily.com/guides/secure-iphone-for-kids',
  smartAlerts: 'https://www.joeyfamily.com/features/smart-alerts',
  iphoneMonitoring: 'https://www.joeyfamily.com/features/iphone-monitoring',
  analytics: 'https://www.joeyfamily.com/features/analytics',
  contactVerification: 'https://www.joeyfamily.com/features/contact-verification',
  howsMyChild: 'https://www.joeyfamily.com/features/hows-my-child-report',
  smartAlertsBullyingHarassment: 'https://www.joeyfamily.com/features/smart-alerts/bullying-harassment',
  smartAlertsConcerningLanguage: 'https://www.joeyfamily.com/features/smart-alerts/concerning-language-hate-speech',
  smartAlertsDrugsAlcohol: 'https://www.joeyfamily.com/features/smart-alerts/drugs-and-alcohol',
  smartAlertsEmotionalDistress: 'https://www.joeyfamily.com/features/smart-alerts/emotional-distress',
  smartAlertsMoneyGifts: 'https://www.joeyfamily.com/features/smart-alerts/money-and-gifts',
  smartAlertsPersonalInformation: 'https://www.joeyfamily.com/features/smart-alerts/personal-information',
  smartAlertsSuspiciousContacts: 'https://www.joeyfamily.com/features/smart-alerts/suspicious-contacts',
  contact: 'https://www.joeyfamily.com/contact',
  privacy: 'https://www.joeyfamily.com/privacy',
  security: 'https://www.joeyfamily.com/security',
  terms: 'https://www.joeyfamily.com/terms',
  founders: 'https://www.joeyfamily.com/founders',
  faqs: 'https://www.joeyfamily.com/faqs',
  articles: 'https://www.joeyfamily.com/articles',
  plansBasic: 'https://www.joeyfamily.com/plans/basic',
  plusComingSoon: 'https://www.joeyfamily.com/plus-coming-soon',
} as const

export type SeoRouteKey = keyof typeof SEO_ROUTES
